import type { LibraryBlockTypeForListPage } from '@ContractBuilder/types';

export type SelectedLibraryBlockSummary = Pick<
  LibraryBlockTypeForListPage,
  'id' | 'name' | 'title' | 'clause_reference' | 'clause_type' | 'type'
>;

export const toSelectedLibraryBlockSummary = (block: LibraryBlockTypeForListPage): SelectedLibraryBlockSummary => ({
  id: block.id,
  name: block.name,
  title: block.title,
  clause_reference: block.clause_reference,
  clause_type: block.clause_type,
  type: block.type,
});
